import { Component } from '@angular/core';

@Component({
  selector: 'app-agent-voice',
  // imports: [],
  templateUrl: './agent-voice.component.html',
  styleUrl: './agent-voice.component.scss'
})
export class AgentVoiceComponent {

}
